import dayjs from "dayjs";
import Big from "big.js";
import { formatToUtc, getDateTimeFromSelectedDate } from "../lib/functions";

export const createPosPayload = ({
  itemCart,
  customer,
  footerValues = {}, // ✅ default empty object
  voucherNumber,
  taxMode,
  payCart,
  entryDate,
  selectedSalesAcc,
  selectedTaxAcc,
  selectedDiscountAcc,
  selectedTransportAcc,
}) => {
  let finalDate = entryDate || new Date();
  if (!dayjs(entryDate).isSame(dayjs(), "day")) {
    finalDate = getDateTimeFromSelectedDate(entryDate);
  }
  const formattedDate = formatToUtc(finalDate);

  const safeFooter = footerValues || {}; // ✅ double safety

  const saleItems = (itemCart || [])
    .filter((it) => it.item_id)
    .map((it) => {
      const qty = new Big(it.qty || 0);
      const rate = new Big(it.rate || 0);
      const lineTotal = qty.times(rate);
      const taxPer = new Big(it.tax_per || 0);
      const taxAmt = lineTotal.times(taxPer).div(100);

      return {
        warehouse_id: it.warehouse_id || 0,
        warehouse_name: it.warehouse_name || "",
        item_id: it.item_id,
        item_name: it.product,
        item_qty: qty.toString(),
        item_rate: rate.toString(),
        item_total: lineTotal.toFixed(13),
        item_discount: 0,
        item_discount_per: new Big(it.discount || 0).toString(),
        item_tax: taxAmt.toFixed(13),
        item_tax_per: taxPer.toString(),
        display_text: `${it.product} - ${it.item_code || ""}`,
        base_unit_name: it.base_unit_name || "",
        conversion: it.conversion || 1,
        per_conversion: it.per_conversion || 1,
        per_unit_id: it.per_unit_id || 0,
        per_unit_symbol: it.per_unit_symbol || "",
        unit_id: it.unit_id || 0,
        unit_name: it.unit_name || "",
        unit_symbol: it.unit_symbol || "",
        units: it.units || [],
        is_serial: "no",
        serials: [],
        sale_qty: qty.toString(),
        sale_rate: rate.toString(),
        retail_qty: Number(it.retail_qty) || 0,
        purchase_average_rate: it.purchase_average_rate || 0,
        discount_acc_id: selectedDiscountAcc.acc_id,
        discount_acc_name: "Discount on sale",
        tax_acc_id: selectedTaxAcc.acc_id,
        tax_acc_name: "duty and tax",
      };
    });

  return {
    sale_id: 0,
    orderId: 0,
    customer: {
      acc_id: customer?.acc_id || 0,
      acc_name: customer?.acc_name || "",
      institution_name: customer?.institution_name || "",
      contact_no: customer?.contact_no || "",
      address: customer?.address || "",
    },
    itemCart: saleItems,
    payCart: (payCart || []).map((p) => ({
      to_acc_id: p.to_acc_id || p.to_acc_id || 0,
      to_acc_name: p.to_acc_name || p.to_acc_name || "",
      tran_amount: Number(p.tran_amount) || 0,
    })),
    masterData: {
      sale_voucher_no: voucherNumber,
      is_serial: "no",
      is_cal_type: taxMode === "on_total" ? "on_total" : "individual",
      sales_acc_id: selectedSalesAcc.acc_id,
      discount_acc_id: selectedDiscountAcc.acc_id,
      tax_acc_id: selectedTaxAcc.acc_id,
      transport_acc_id: selectedTransportAcc.acc_id,
      narration: safeFooter.description || "", // ✅ safe
      created_date: formattedDate,
      due_amount: safeFooter.dueAmount || 0,
      due_date: safeFooter.dueAmount > 0 ? footerValues?.dueDate : "",
      is_emi: footerValues?.emis?.length > 0 ? "yes" : "no",
      is_condition_sale: "no",
      challan_text: footerValues?.challanText,
      sub_total: safeFooter.subtotal || "0.00",
      total_discount_per: safeFooter.discountPct || 0,
      total_discount: safeFooter.total_discount || "0.00",
      total_discount_mode: safeFooter?.discountMode === "amount" ? "amount" : "percent",
      total_tax_per: safeFooter.taxPct || 0,
      total_tax: safeFooter.totalTax || "0.00",
      total_transport_cost: safeFooter.transportCost || 0,
      total_amount: safeFooter.grandTotal || "0.00",
      paid_amount: safeFooter.paidAmount || 0,
    },
    total_discount_per: safeFooter.discountPct || 0,
    total_discount: safeFooter.total_discount || "0.00",
    sub_total: safeFooter.subtotal || "0.00",
    due_amount: safeFooter.dueAmount || 0,
    created_date: formattedDate,
    is_emi: "no",
    emi_month: 0, // ✅ move here
    emis: [],
    emi_amount: 0,
    day_week: "0",
  };
};
